import { AvailablePlan } from '@dtx-company/inter-app/src/types/AvailablePlan'
import {
  GetAvailablePlansOptions,
  getAvailablePlans
} from '@dtx-company/inter-app/src/api/subscription-service/getAvailablePlans'
import {
  UseAPIConfig,
  UseAPIOptions,
  UseAPIResponse,
  useAPI
} from '@dtx-company/inter-app/src/hooks/useAPI'

export type UseAvailablePlansConfig = UseAPIConfig<AvailablePlan[], Error>
type UseAvailablePlansOptions = UseAPIOptions<GetAvailablePlansOptions>
export type UseAvailablePlansResponse = UseAPIResponse<AvailablePlan[], Error>

/**
 * Wraps useSWR to retrieve available subscription plans from the api.
 */
export function useAvailablePlansSWR(
  options: UseAvailablePlansOptions,
  config?: UseAvailablePlansConfig
): UseAvailablePlansResponse {
  return useAPI<GetAvailablePlansOptions, AvailablePlan[], Error>(
    'useAvailablePlans',
    getAvailablePlans,
    options,
    config
  )
}
